/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FirebaseConfig } from '../models/FirebaseConfig';
import type { UserInfo } from '../models/UserInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class UserService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get user details
   * @returns UserInfo Successful response
   * @throws ApiError
   */
  public user(): CancelablePromise<UserInfo> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/user',
      errors: {
        401: `The request was not authorized. Most likely you forgot to send the API key in the header \`Authorization\`.`,
        403: `You are not allowed to perform the requested operation on this resource.`,
      },
    });
  }

  /**
   * Get Firebase configuration
   * @returns FirebaseConfig Successful response
   * @throws ApiError
   */
  public getFirebaseConfig(): CancelablePromise<FirebaseConfig> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/firebase-config',
      errors: {
        401: `The request was not authorized. Most likely you forgot to send the API key in the header \`Authorization\`.`,
        403: `You are not allowed to perform the requested operation on this resource.`,
      },
    });
  }

}
